(function () {

    'use strict';

    angular.module('app').controller('ShipmentsViewController', ShipmentsViewController);

    ShipmentsViewController.$inject = [
        '$filter',
        '$routeParams',
        'Shipments',
        'MarketPlaceService',
        '$q',
        'toastr',
        '$timeout',
        'CommonService',
        'Units',
        '$location',
        'ConfirmationModalFactory',
        'Packages',
        '$window',
        '$uibModal',
        '$rootScope',
        'trackingStatusesConst',
        'FleetService',
        'RefStatusesConst'
    ];

    function ShipmentsViewController(
        $filter,
        $routeParams,
        Shipments,
        MarketPlaceService,
        $q,
        toastr,
        $timeout,
        CommonService,
        Units,
        $location,
        ConfirmationModalFactory,
        Packages,
        $window,
        $uibModal,
        $rootScope,
        trackingStatusesConst,
        FleetService,
        RefStatusesConst
    ) {
        let viewConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.archive.MESSAGE',
            code: 'messages.warning.archive.CODE',
        });

        const deleteConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.deleteShipment.MESSAGE',
            code: 'messages.warning.deleteShipment.CODE'
        });

        var vm = this;
        vm.params = $routeParams;
        vm.shipmentID = $routeParams.id;
        vm.printLabels = printLabels;
        vm.requestPod = requestPod;
        vm.back = back;
        vm.archive = archive;
        vm.showShippingCostDetails = showShippingCostDetails;
        vm.updateTrackingNumber = updateTrackingNumber;
        vm.updatePickupReferenceNumber = updatePickupReferenceNumber;
        vm.toggleEditForm = toggleEditForm;
        vm.downloadReceipt = downloadReceipt;
        vm.downloadDocuments = downloadDocuments;
        vm.deleteShipment = deleteShipment;
        vm.createNewClaim = createNewClaim;
        vm.changeStatus = changeTrackingStatusModal;
        vm.refStatus = RefStatusesConst.refStatus;

        init();

        function init() {
            getShipmentDetails();
        }

        function getShipmentDetails() {
            Shipments.getShipmentDetails(vm.shipmentID, function (data) {
                vm.isDomestic = CommonService.isDomesticFn(data.sourceAddress, data.destinationAddress);
                vm.trackingStatuses = Object.keys(trackingStatusesConst.trackingStatuses);
                vm.trackingStatusesValue = trackingStatusesConst.trackingStatuses;

                if (data.paymentType !== null) {
                    vm.paymentType = data.paymentType.charAt(0).toUpperCase() + data.paymentType.slice(1)
                }

                vm.data = data;
                vm.data.scannedDate = new Date(data.scannedDate).getTime();
                vm.originalData = angular.copy(data);
                data.sourceAddress.viewHeader = 'Collection Address';
                data.destinationAddress.viewHeader = 'Destination Address';
                vm.addresses = [data.sourceAddress, data.destinationAddress];

                vm.fuelLevy = setFuelLevyValue(data);
                if (vm.data.bookingDate && vm.data.deliveredDate) {
                    vm.data.daysInTransit = hoursDifference(vm.data.deliveredDate, vm.data.bookingDate);
                }

                vm.totalCostFormatted = Shipments.getShipmentCostFormatted(data);
                getFormattedAllDeadWeigthAndCubicWeightTotal();

                vm.optionalExtras = getOptionalExtras();
                iterateItems(vm.data);
                iteratePackages(vm.data);
                getMarketplace(data);
                getTrackingDetails(data);
                checkIfManualTrackingIsEnabled();
                getJobDetails(data);
                carrierOptionDisplay(data.carrierBookingOptions)
            });
        }

        function carrierOptionDisplay(data) {
            const objectDisplay = Object.keys(data);
            const orderNum = [0, 4, 1, 5, 2, 6]
            vm.carrierBookingOptionsDisplay = [];

            for (let i = 0; i < objectDisplay.length; i++) {
                if (orderNum[i]) {
                    const nameData = objectDisplay[orderNum[i]];
                    vm.carrierBookingOptionsDisplay.push({
                        text: objectDisplay[orderNum[i]],
                        value: data[nameData]
                    })
                } else {
                    vm.carrierBookingOptionsDisplay.push({
                        text: objectDisplay[i],
                        value: data[objectDisplay[i]]
                    })
                }
            }
        }

        function getJobDetails(shipment) {
            if (!shipment.job) { return; }
            FleetService.Jobs.getJobDetails(shipment.job.id, data => {
                vm.job = data;
            }, error => {
                toastr.error(error.message, "Error");
            });
        }

        function carrierOptionDisplay(data) {
            const objectDisplay = Object.keys(data);
            const orderNum = [0, 4, 1, 5, 2, 6];
            vm.carrierBookingOptionsDisplay = [];
            for (let i = 0; i < objectDisplay.length; i++) {
                if (orderNum[i]) {
                    const nameData = objectDisplay[orderNum[i]];
                    vm.carrierBookingOptionsDisplay.push({
                        text: objectDisplay[orderNum[i]],
                        value: data[nameData]
                    })
                } else {
                    vm.carrierBookingOptionsDisplay.push({
                        text: objectDisplay[i],
                        value: data[objectDisplay[i]]
                    })
                }
            }
        }

        function checkIfManualTrackingIsEnabled() {
            vm.isManualUpdateDisabled = $rootScope.GlobalProfile.office.enableUpdate;
        }

        function setFuelLevyValue(data) {
            let fuelLevy = {
                fixed: 0,
                percentage: 0
            };
            var fuelLevyTemp = angular.getObjVal(data, 'serviceProfile.fuelLevy.enabled') ? data.serviceProfile.fuelLevy.details : null;
            if (fuelLevyTemp && fuelLevyTemp.active) {
                fuelLevy.fixed = (fuelLevyTemp.fixed ? $filter(currency)(fuelLevyTemp.fixed, '') : 0) + ' ' + fuelLevyTemp.currency;
                fuelLevy.percentage = fuelLevyTemp.percentage ? fuelLevyTemp.percentage + ' %' : '0 %';
            }
            return fuelLevy;
        }

        function decimalCeil(num) {
            return Math.ceil(num * 100) / 100;
        }

        function getShortMeasure(value) {
            const unit = Units.measureUnit.find(unit => unit.value === value || unit.full === value || unit.short === value) || null;
            return unit ? unit.short : '';
        }

        function getShortWeight(value) {
            const unit = Units.weightUnit.find(unit => unit.value === value || unit.full === value || unit.short === value) || null;
            return unit ? unit.short : '';
        }

        function getFormattedItemUnits(item) {
            const measureUnit = getShortMeasure(item.measureUnit).toUpperCase();
            const weightUnit = getShortWeight(item.weightUnit).toUpperCase();
            return {
                widthFormatted: `${decimalCeil(item.width)} ${measureUnit}`,
                lengthFormatted: `${decimalCeil(item.length)} ${measureUnit}`,
                heightFormatted: `${decimalCeil(item.height)} ${measureUnit}`,
                weightFormatted: `${decimalCeil(item.weight)} ${weightUnit}`,
                cubicWeightFormatted: `${decimalCeil(item.cubicWeight)} ${weightUnit}`,
                totalCubicWeightFormatted: `${decimalCeil(item.totalCubicWeight)} ${weightUnit}`,
                totalDeadWeightFormatted: `${decimalCeil(item.totalDeadWeight)} ${weightUnit}`
            }
        }

        function iteratePackages(shipment) {
            angular.forEach(shipment.packages, pack => {
                angular.extend(pack, getFormattedItemUnits(pack));
            });
            startFetch();

            function startFetch() {
                return shipment.packages.reduce(function (promise, criteria, index) {
                    return promise.then(function (data) {
                        angular.extend(shipment.packages[index], {
                            packagingName: data.name
                        });
                        if (index === shipment.packages.length - 1) {
                            return;
                        }
                        return getPackage(shipment.packages[index + 1]);
                    });
                }, getPackage(shipment.packages[0]))
            }
        }

        function iterateItems(shipment) {
            angular.forEach(shipment.items, item => {
                angular.extend(item, getFormattedItemUnits(item));
            });
        }

        function getFormattedAllDeadWeigthAndCubicWeightTotal() {
            if (vm.data.packages.length !== 0) {
                vm.data.totalCubicWeightFormatted = `${vm.data.totalCubicWeight || 0} ${getShortWeight(vm.data.packages[0].weightUnit).toUpperCase()}`;
                vm.data.totalDeadWeightFormatted = `${vm.data.totalDeadWeight || 0} ${getShortWeight(vm.data.packages[0].weightUnit).toUpperCase()}`;
            }
        }

        function getTrackingDetails(shipment) {
            vm.fetchingTracking = true;
            Shipments.getTracking(shipment.id, data => {
                let base = '.bbamastro.com';
                if ($window.location.href.indexOf('alfalogistics.com') > 0) {
                    base = '.alfalogistics.com.au';
                }
                if ($window.location.href.indexOf('srktransport.com.au') > 0) {
                    base = '.srktransport.com.au';
                }
                let env = getEnv();
                vm.data.tracking = data;
                if (vm.data.tracking)
                    vm.data.tracking.dashboardUrl = `https://dashboard${env}${base}/tracking/${vm.data.consignmentId}`;
                vm.fetchingTracking = false;
            }, error => {
                //toastr.error('Unable to get tracking details', error.message);
                vm.fetchingTracking = false;
            });
        }

        function getMarketplace(data) {
            const defer = $q.defer();
            if (data.marketplaceId) {
                MarketPlaceService.get(data.marketplaceId, function (response) {
                    defer.resolve(response);
                    vm.data.marketplace = response;
                }, function (err) {
                    defer.reject(err);
                    //toastr.error('unable to get marketplace', err.message);
                });
            } else {
                $timeout(() => {
                    defer.resolve(null);
                })
            }
            return defer.promise;
        }

        function getPackage(pack) {
            const defer = $q.defer();
            if (!angular.getObjVal(pack, 'packagingId')) {
                defer.resolve({});
            } else {
                Packages.getPackage(pack.packagingId, function (data) {
                    defer.resolve(data);
                });
            }
            return defer.promise;
        }

        function getOptionalExtras() {
            let extras = '';
            //PO Box, Tailgate, Dangerous Goods, COP, Unattended Delivery
            if (vm.poBox) extras += ', PO Box';
            if (vm.dangerousGoods) extras += ', Dangerous Goods';
            if (vm.tailGate) extras += ', Tailgate';

            return !_.isEmpty(extras) ? extras.substr(2, extras.length) : "No Extra's Declared";
        }

        function printLabels() {
            if (vm.data.consignmentId) {
                CommonService.printDocuments(vm.data);
            }
        }

        function requestPod() {
            vm.downloadingPOD = true;
            Shipments.downloadPOD(vm.data.id, success => {
                vm.downloadingPOD = false;
            }, error => {
                if (error.code == "404") {
                    if (vm.data.carrierConfiguration.carrierId === "direct-freight-express" || vm.data.carrierConfiguration.carrierId === "aramex") {
                        noPODDocuments();
                    }
                    toastr.warning(`No POD found for this shipment`, 'Warning');

                } else {
                    toastr.error(error.message, "Error");
                }
                vm.downloadingPOD = false;
            });
        }

        function noPODDocuments() {
            const noPODDocuments = new ConfirmationModalFactory({}, {
                message: `Proof of Delivery for this shipment can only be downloaded via ${vm.data.carrierConfiguration.carrierName} portal.`,
                code: 'messages.warning.deleteShipment.CODE'
            });

            noPODDocuments.getInstance().result.then(function (cond) {

            })
        }

        function hoursDifference(day1, day2) {
            let differenceStr = '';
            let dayMS = 24 * 60 * 60 * 1000;
            let firstDate = new Date(day1);
            let secondDate = new Date(day2);
            let diffDays = Math.abs((firstDate.getTime() - secondDate.getTime()) / (dayMS));
            let remHrs = Math.abs((diffDays - Math.floor(diffDays)) * 24);

            if (Math.floor(diffDays))
                differenceStr += Math.floor(diffDays) + ' Day(s) ';
            if (Math.floor(remHrs))
                differenceStr += Math.floor(remHrs) + ' Hour(s)';

            return differenceStr;
        }

        function archive(id) {
            viewConfirmation.getInstance().result.then(function (cond) {
                if (cond) {
                    reasonToCancelModal([id])
                    // Shipments.archiveShipments([id], () => {
                    //     toastr.success('Shipment successfully archived');
                    //     $location.path('/shipments');
                    // }, () => {
                    //     toastr.error('Unable to archive shipment.', 'Please try again later');
                    // });
                }
            });
        }

        function changeTrackingStatusModal(){
                $uibModal.open({
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: '/templates/pages/shipments/modal/change-trackingStatus-modal.html',
                    controller: 'ChangeTrackingStatusModalController',
                    controllerAs: 'vm',
                    keyboard: false,
                    // backdrop: 'static',
                    // windowClass: 'loading-indicator',
                    size: 'md',
                    resolve: {
                        shipmentIds: () => {
                            return [vm.shipmentID];
                        }
                    },
                    // appendTo: $('body')
                }).result.then((result) => {
                    if (result) {
                        $window.history.back();
                    }
                });;
            }

        function reasonToCancelModal(selected){
                $uibModal.open({
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: '/templates/pages/shipments/modal/reason-cancellation-modal.html',
                    controller: 'ReasonOfCancellationModalController',
                    controllerAs: 'vm',
                    keyboard: false,
                    // backdrop: 'static',
                    // windowClass: 'loading-indicator',
                    size: 'md',
                    resolve: {
                        shipmentIds: () => {
                            return selected;
                        }
                    },
                    // appendTo: $('body')
                }).result.then((result) => {
                    if (result) {
                        $window.history.back();
                    }
                });;
            }

        function back() {
            $window.history.back();
        }

        function getEnv() {
            const baseUrl = $window.location.href;
            let env = '';
            if (baseUrl.indexOf('-staging') !== -1) {
                env = '-staging';
            } else if (baseUrl.indexOf('-dev') !== -1) {
                env = '-dev';
            } else if (baseUrl.indexOf('-demo') !== -1) {
                env = '-demo';
            }
            return env;
        }

        function showShippingCostDetails() {
            const modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                windowClass: 'setting-modal',
                templateUrl: '/templates/modal/job-financial-details-modal.html',
                controller: 'JobFinancialDetailsModalController',
                controllerAs: 'vm',
                size: 'lg',
                appendTo: $('body'),
                resolve: {
                    data: function () {
                        return vm.data
                    }
                }
            });
        }

        function updateTrackingNumber(...forms) {
            vm.updatingData = true;

            const validForms = forms.every(form => {
                form.$setSubmitted;
                return form.$valid;
            });
            if (!validForms) return false;

            if (vm.trackingNumberForm.$valid) {
                Shipments.updateTracking(vm.shipmentID, vm.data.trackingNumber, vm.data.trackingStatus, data => {
                    vm.data = data;
                    vm.updatingData = false;
                    toastr.success('Shipment Updated', 'Success');
                }, error => {
                    toastr.error(error.message, 'Error');
                    vm.updatingData = false;
                });
            } else {
                vm.updatingData = false;
            }
        }

        function toggleEditForm() {
            vm.showEditForm = !vm.showEditForm;
        }

        function updatePickupReferenceNumber(form) {
            form.$setSubmitted();
            if (form.$invalid) return false;
            if (vm.updating) return false;
            initiateDataUpdate();
        }

        function initiateDataUpdate() {
            vm.updating = true;
            Shipments.updateCarrierOrderId(success => {
                toastr.success('Booking/Pickup Reference No. Updated', 'Success');
                vm.updating = false;
                vm.showEditForm = false;
            }, error => {
                toastr.error(error.message, 'Error');
                vm.updating = false;
            }, vm.data.id, vm.data.carrierOrderId);
        }

        function downloadReceipt() {
            Shipments.downloadReceipt(success => {
                toastr.success('Receipt Downloaded', 'Error');
            }, error => {
                toastr.error('Failed to download invoice', 'Error');
            }, vm.shipmentID);
        }

        function downloadDocuments() {
            Shipments.requestShipmentDocs(vm.shipmentID,
                res => {
                    toastr.success('Documents Downloaded', 'Success');
                },
                err => {
                    toastr.error('No Documents uploaded', 'Error');
                });
        }

        function deleteShipment() {
            deleteConfirmation.getInstance().result.then(function (cond) {
                if (cond) {
                    vm.isDeleting = true;
                    Shipments.deleteShipment(data => {
                        toastr.success(`Shipemnt ${vm.shipmentID} has been deleted`, 'Success');
                        $location.path('/shipments');
                        vm.isDeleting = false;
                    }, error => {
                        toastr.error(error.message, "Error");
                        vm.isDeleting = false;
                    }, vm.shipmentID);
                }
            });
        }

        function createNewClaim() {
            vm.isCreatingClaim = true;
            const modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: '/templates/pages/transit-warranty/modal/transit-warranty-claim-details-modal.html',
                controller: 'TransitWarrantyClaimDetails',
                controllerAs: 'vm',
                size: 'md',
                appendTo: $('body'),
                resolve: {
                    shipment: () => vm.data,
                    claimDetails: () => null
                }
            });

            modalInstance.result.then(() => {
                vm.isCreatingClaim = false;
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/shipment/ShipmentsViewController.js